import { alertConstants } from "../../constants";

export function alert(state={}, action) {
  switch (action.type) {
    case alertConstants.ALERT_ERROR:
      return {
        type: "error",
        message: action.payload.message,
      };
    case alertConstants.ALERT_INFO:
      return {
        type: "info",
        message: action.payload.message,
      };
    case alertConstants.ALERT_SUCCESS:
      return {
        type: "success",
        message: action.payload.message,
      };
    case alertConstants.ALERT_WARNING:
      return {
        type: "warning",
        message: action.payload.message,
      };
    case alertConstants.ALERT_RESET:
      return {};
    default:
      return state;
  }
}